import { knownUnits } from '../../models/knownUnits.model';

export class CounterHelper {
  public static GetCounterCoefficient(unitId: string): number {
    if (this.IsWholeUnit(unitId)) {
      return 1;
    } else {
      return 100;
    }
  }

  public static IsWholeUnit(unitId: string): boolean {
    if (unitId == undefined || unitId == null) {
      return true;
    }
    return knownUnits.WholeUnits.some((unitName: string) => unitId?.startsWith(unitName));
  }

  public static roundToPrecision(value: number, unitId: string): number {
    const coeff = this.GetCounterCoefficient(unitId);
    return Math.floor(value * coeff) / coeff;
  }
}